var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { Typography } from "../Typography/Typography";
import { useLink } from "../../hooks/useLink";
import { useTheme } from "../../hooks/useTheme";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: '100%',
        border: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        transition: theme.transitions.duration.shorter + "ms",
        userSelect: 'none',
        cursor: 'pointer',
        textDecoration: 'none',
        margin: theme.spacing(0),
    },
    light: {
        backgroundColor: theme.palette.light.background.paper,
        color: theme.palette.light.text.primary,
        // FIXME #21 ホバーの表現が共通化されたら修正する
        '&:hover:not(:active)': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:active': {
            backgroundColor: theme.palette.action.active,
        },
        '&:focus': {
            outlineWidth: '0',
        },
    },
    dark: {
        backgroundColor: theme.palette.dark.background.paper,
        color: theme.palette.dark.text.primary,
        '&:hover:not(:active)': {
            color: theme.palette.primary.light,
        },
        '&:disabled': {
            color: theme.palette.dark.text.disabled,
        },
        '&:active': {
            color: theme.palette.dark.text.primary,
            backgroundColor: theme.palette.primary.light,
        },
    },
    icon: {
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(1),
        color: 'inherit',
    },
    label: {
        color: 'inherit',
    },
    slider: {
        width: '100%',
        position: 'absolute',
        opacity: 0,
        transition: theme.transitions.duration.shorter + "ms",
        left: 0,
        bottom: 0,
        height: 6,
    },
    sliderLight: {
        backgroundColor: theme.palette.primary.main,
    },
    sliderDark: {
        backgroundColor: theme.palette.dark.text.primary,
    },
    disabled: {
        pointerEvents: 'none',
        '&$selected': {
            borderBottom: '0',
        },
    },
    disabledLight: {
        color: theme.palette.light.action.disabled,
        backgroundColor: theme.palette.light.background.paper,
    },
    disabledDark: {
        color: theme.palette.dark.text.disabled,
        borderColor: theme.palette.dark.action.disabled,
    },
    selected: {
        pointerEvents: 'none',
    },
    sliderSelected: {
        opacity: 1,
    },
}); }, { name: 'SnHeaderTabButton' });
export var HeaderTabButton = function (props) {
    var _a, _b;
    var light = props.light, dark = props.dark, disabled = props.disabled, selected = props.selected, name = props.name, id = props.id, Icon = props.icon, onClick = props.onClick, style = props.style, others = __rest(props, ["light", "dark", "disabled", "selected", "name", "id", "icon", "onClick", "style"]);
    var classes = useStyles(props);
    var theme = useTheme({ light: light, dark: dark });
    var Component = useLink(props, 'button');
    var handleClick = useCallback(function () {
        onClick(id);
    }, [id, onClick]);
    var className = classNames(classes.root, classes[theme.type], (_a = {},
        _a[classes.selected] = selected,
        _a[classes.disabled] = disabled,
        _a[classes.disabledLight] = disabled && !theme.isDark,
        _a[classes.disabledDark] = disabled && theme.isDark,
        _a));
    var sliderClass = classNames(classes.slider, (_b = {},
        _b[classes.sliderLight] = !theme.isDark,
        _b[classes.sliderDark] = theme.isDark,
        _b[classes.sliderSelected] = selected,
        _b));
    return (React.createElement(Component, __assign({ className: className, onClick: handleClick, disabled: disabled, style: style }, others),
        Icon && React.createElement(Icon, { className: classes.icon }),
        React.createElement(Typography, { variant: "body1", bold: true, className: classes.label }, name),
        React.createElement("div", { className: sliderClass })));
};
